/*
Goals:
1) Create a channel for each track using synthesizer.getChannel().
2) Play notes with channel.playNote() and channel.stopNote().
3) Manage time with delayAsync() and buildTimer().
4) Gracefully handle the "Stop" button (see below).
5) Tests are not required, but include comments to explain how you are solving problems.
6) Make sure your program is resilient to errors. Even though no failures are expected in this demo, exceptions and edge cases should be gracefully handled at every stage.

Stack Overflow Sources:
Running functions in parallel async Javascript: https://stackoverflow.com/questions/35612428/call-async-await-functions-in-parallel

How to resolve an unknown amount of promises: https://stackoverflow.com/questions/55938388/promises-how-to-resolve-an-unknown-amount-of-promises

How to use setTimeout with async/await in JavaScript:
https://www.pentarem.com/blog/how-to-use-settimeout-with-async-await-in-javascript/

Async/Await Exercise:
https://replit.com/join/delpzdpbkr-quyencodes

*/

// import { delayAsync, buildTimer } from '../util.ts';
import { buildTimer } from '../util.ts';

export async function player(synthesizer, tracks) {
  try {
    let promises = []

    tracks.forEach((track, index) => {
      promises.push(playInstrument(track, synthesizer))
    })

    await Promise.all([...promises])
  }
  catch(error) {
    console.log(error)
  }
  finally {
    console.log('This line will play no matter what, resolve or reject cases')
  }
}

async function playInstrument(track, synthesizer) {

  const instrumentName = track["instrumentName"]
  const notes = track["notes"]
  sortNotes(track["notes"]) // Need to sort for Tetris case

  const channel = synthesizer.getChannel(instrumentName)
  let timer = buildTimer()

  for (const note of notes) {
    let musicalNotation = note["name"]
    let musicalVelocity = note["velocity"]
    let noteDuration = note["duration"]
    let startTime = note["time"]

    await delay(startTime - timer())

    // Need to pass music notation and velocity to the synthesizer
    // playNote returns a boolean: false indicates Stop button was pressed
    const current = channel.playNote(musicalNotation, musicalVelocity)

    if (!current) {
      break;
    }

    await _delayAsync(noteDuration)
    channel.stopNote()
  }
}


function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

// Created identical delayAsync function without reentrancy issue
async function _delayAsync(duration) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(undefined);
    }, duration);
  })
}

function sortNotes(notes) {
  notes.sort((a, b) => {
    return a.time - b.time
  })
}

// Created a function to isolate when to play a note
// async function startNote(startTime, channel, musicalNotation, musicalVelocity, noteDuration, timer) {
//   await delay(startTime - timer())
//   // Need to pass music notation and velocity to the synthesizer
//   // playNote returns a boolean: false indicates Stop button was pressed
//   const current = channel.playNote(musicalNotation, musicalVelocity)

//   if (!current) {
//     return
//   }

//   await _delayAsync(noteDuration)
//   channel.stopNote()
// }